'use client'

import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import {
  Maybe,
  Price as VariantPrice,
} from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import { useLayout } from '@dustin-web/microsite-components/src/hooks'
import type { Base } from './product-price'
import Price from './product-price'

export type PriceType = {
  originalPrice: number
  campaignPercentage?: Maybe<number>
  formatted: { price: string; originalPrice: string }
  price: number
  isCampaign: boolean
  priceVat: number
}
type Props = {
  price?: Maybe<PriceType>
  displayVatInfo: boolean
  className?: string
  stripped?: boolean
  priceClassName?: string
  campaignClassName?: string
}

const Container = (props: Base) => {
  const { incExVatTranslation } = useI18n()
  const { responsive } = useLayout()
  return (
    <Price
      isScreenMinMD={responsive.breakpoints.min.MD}
      vatInfoPrice={incExVatTranslation(props.priceVat)}
      {...props}
    />
  )
}

type VariantPriceProps = {
  price?: Maybe<VariantPrice>
  displayVatInfo: boolean
  className?: string
  stripped?: boolean
  priceClassName?: string
  campaignClassName?: string
}

export const ProductPrice = (props: Props | VariantPriceProps) => {
  if (props.price?.formatted) {
    // is regular Price type
    return (
      <Container
        isCampaign={props.price.isCampaign}
        price={props.price.formatted.price}
        originalPrice={props.price.formatted.originalPrice}
        displayVatInfo={props.displayVatInfo}
        stripped={props.stripped}
        className={props.className}
        priceClassName={props.priceClassName}
        campaignClassName={props.campaignClassName}
      />
    )
  }
  return (
    <Container
      isCampaign={props.price?.isCampaign || false}
      price={props.price?.price}
      originalPrice={props.price?.originalPrice}
      displayVatInfo={props.displayVatInfo}
      stripped={props.stripped}
      className={props.className}
      priceClassName={props.priceClassName}
      campaignClassName={props.campaignClassName}
    />
  )
}

export default ProductPrice
